import { createContext, ReactNode, useContext } from "react";

export const CustomButtonContext = createContext<{
  customButtons?: ReactNode[];
}>({});

export const useCustomButtons = () => useContext(CustomButtonContext);
